/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import { components } from "react-select";
import { arrowCss } from "./index.css";

export default function DropdownIndicator(props) {
  return (
    <components.DropdownIndicator {...props}>
      <span css={arrowCss} />
    </components.DropdownIndicator>
  );
}
